jQuery(document).ready(function ($) {
  const topInfoBar = $('#header-info-bar');
  const hasTopInfoBar = topInfoBar.length > 0 && topInfoBar.css('display') !== 'none';

  if (!hasTopInfoBar) {
    return;
  }

  const headerBar = $('#header-bar');
  const headerBarMobile = $('#header-bar-mobile');
  const mainHeader = $('.elementor-location-header');

  // if ($('body').hasClass('admin-bar')) {
  //   mainHeader.css('padding-top', (isMobileView() ? '56px' : '126px'));
  //   topInfoBar.css('top', (isMobileView() ? '0' : '32px'));
  //   headerBar.css('top', '60px');
  //   headerBarMobile.css('top', '56px');
  //   return;
  // }
  mainHeader.css('padding-top', isMobileView() ? '118px' :  '94px');
  headerBar.css('top', '28px');
  headerBarMobile.css('top', '56px');

  function isMobileView() {
    return window.matchMedia('(max-width: 480px)').matches;
  }
});